import { prop } from 'datx';
import { BaseModel } from './BaseModel';

interface IPrice {
  amount: string;
  currency: string;
}

export class Wrap extends BaseModel {
  public static type = 'wrap';

  @prop
  public id!: number;

  @prop
  public descriptionUid!: string;

  @prop
  public uid!: string;

  @prop
  public isSelected!: boolean;

  @prop
  public previewDesktop!: Record<string, string>;

  @prop
  public previewMobile!: Record<string, string>;

  @prop
  public price!: IPrice;
}
